// <s-wishlist-button> — heart toggle on product cards. Command: --toggle (from its child button via commandfor). Keeps aria-pressed in sync across cards and tabs.
import { WISHLIST_EVENT, WISHLIST_KEY, hasWishlistItem, toggleWishlistItem } from '@theme/wishlist-store';

class SWishlistButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.#sync();
    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      toggleWishlistItem(this.dataset.productId, this.dataset.productUrl);
    }, { signal });
    document.addEventListener(WISHLIST_EVENT, () => this.#sync(), { signal });
    window.addEventListener('storage', (event) => {
      if (event.key === WISHLIST_KEY) this.#sync();
    }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync() {
    const button = this.querySelector('button');
    if (button) button.setAttribute('aria-pressed', String(hasWishlistItem(this.dataset.productId)));
  }
}

if (!customElements.get('s-wishlist-button')) customElements.define('s-wishlist-button', SWishlistButton);
